/**
 * @module modules/tricon2-sk
 * @description <h2><code>tricon2-sk</code></h2>
 *
 * The triage state icons.
 *
 * @attr {string} value - A string representing the triage status, one of
 *     "untriaged", "positive", or "negative".
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TriconSk", {
    enumerable: true,
    get: function() {
        return TriconSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
require("../../../elements-sk/modules/icons/check-circle-icon-sk");
require("../../../elements-sk/modules/icons/cancel-icon-sk");
require("../../../elements-sk/modules/icons/help-icon-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let TriconSk = class TriconSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        switch(this.value){
            case 'positive':
                return (0, _lit.html)`<check-circle-icon-sk></check-circle-icon-sk>`;
            case 'negative':
                return (0, _lit.html)`<cancel-icon-sk></cancel-icon-sk>`;
            default:
                return (0, _lit.html)`<help-icon-sk></help-icon-sk>`;
        }
    }
    constructor(...args){
        super(...args);
        this.value = '';
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: String,
        reflect: true
    }),
    _ts_metadata("design:type", String)
], TriconSk.prototype, "value", void 0);
TriconSk = _ts_decorate([
    (0, _decorators.customElement)('tricon2-sk')
], TriconSk);
